import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithQuery, Types } from '../ducks';
import { EndpointCreator, EntityWithId, IClient, IGetCollectionActions } from '../interfaces';
import { getEndpoint } from './endpoint';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* getCollection<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IGetCollectionActions<T>,
  params?: { [key: string]: string },
  queryParams?: { [key: string]: string },
) {
  yield put(actions.startGetCollection());

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failGetCollection("couldn't create endpoint"));
  }

  try {
    const entities: EntityWithId<T>[] = yield call([client, 'getCollection'], `${endpoint}`, queryParams);
    return yield put(actions.completeGetCollection(entities));
  } catch (error) {
    return yield put(actions.failGetCollection((error as Error).message));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function newGetCollectionSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IGetCollectionActions<T>,
  service: S,
) {
  const isGetCollection = (action: Action<T, S>) =>
    action.type === Types.GET_COLLECTION_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isGetCollection as any, (action: RequestWithQuery<S>) =>
      getCollection(client, endpointCreator, actions, action.payload.params, action.payload.query),
    );
  };
}
